import { createContext, useCallback, useContext, useMemo, useState } from "react";

const ExpandedContext = createContext()

export function ExpandProvider({children}) {
    const [expandedId, setExpandedId] = useState(null)
    const handleExpand = useCallback(id => {
        setExpandedId(prev => (prev === id ? null : id))
    }, [])
    const collapseAll = useCallback(() => setExpandedId(null), [])

    const props = useMemo(() => ({expandedId, handleExpand, collapseAll}), [expandedId, handleExpand, collapseAll])

    return(
        <ExpandedContext.Provider value={props}>
            {children}
        </ExpandedContext.Provider>
    )
}

export const useExpand = (id) => {
    const { expandedId, handleExpand} = useContext(ExpandedContext)
    const expanded = expandedId === id

    return {
        expanded,
        handleExpand: () => handleExpand(id)
    }
}

export const useExpandedId = () => useContext(ExpandedContext)?.expandedId
export const useCollapseAll = () => useContext(ExpandedContext)?.collapseAll
